function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions as modalActions } from '../../../reducers/modal.reducer';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import Label from '../../common/form/Label.react';
import Select from '../../common/form/Select.react';
import ModalHeader from '../../modal/ModalHeader.react';
var LocationSlot = function LocationSlot(_ref) {
  var locationID = _ref.locationID,
    app = _ref.app;
  var dispatch = useDispatch();
  var locationList = useSelector(function (s) {
    return s.ppc.location.index;
  });
  var _useState = useState({
      slot: null,
      locations: [],
      article: {}
    }),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var slot = form.slot,
    locations = form.locations;
  useEffect(function () {
    var tmp = Object.values(locationList).filter(function (x) {
      return !x.archived;
    }).filter(function (x) {
      return x.clientApp === app;
    }).map(function (x) {
      return {
        _id: x._id,
        name: x.name,
        slot: parseInt(x.slot) || 0
      };
    });
    setForm(_objectSpread(_objectSpread({}, form), {}, {
      locations: tmp
    }));
  }, [locationList]);
  var slotArr = locations === null || locations === void 0 ? void 0 : locations.sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return {
      _id: x._id,
      sLabel: x.slot,
      sValue: x.slot,
      sName: x.name
    };
  });
  var handleOnChange = function handleOnChange(_ref2) {
    var sValue = _ref2.sValue;
    var arr = [];
    var tmpArr = slotArr.filter(function (x) {
      return x._id !== locationID;
    });
    var count = 0;
    for (var i = 0; i < tmpArr.length + 1; i++) {
      if (i === sValue) arr.push({
        slot: sValue,
        locationID: locationID
      });else {
        arr.push({
          slot: i,
          locationID: tmpArr[count]._id
        });
        count++;
      }
    }
    dispatch({
      type: ppcActions.location,
      payload: {
        formData: {
          arr: arr,
          app: app
        },
        route: 'slot',
        method: 'put'
      }
    });
    dispatch({
      type: modalActions.hide
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Update Slot"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, /*#__PURE__*/React.createElement(Label, {
    label: "Slot"
  }), /*#__PURE__*/React.createElement(Select, {
    value: slot,
    options: slotArr,
    onChange: function onChange(_ref3) {
      var sValue = _ref3.sValue;
      handleOnChange({
        sValue: sValue
      });
    },
    placeholder: "Select Slot"
  })));
};
export default LocationSlot;